import { FetchRejectionReasons, FetchRejectionReasonsToDecline } from 'src/constants/actionTypes'
import { Action } from 'src/utils/reduxUtils'
import { RejectionReasonState } from './types'

const getInitialState = (): RejectionReasonState => ({
  rejectionReasons: [],
  rejectionReasonsToDecline: [],
})

export const rejectionReasonReducer = (
  state: RejectionReasonState = getInitialState(),
  action: Action<any>,
): RejectionReasonState => {
  switch (action.type) {
    case FetchRejectionReasons.type.SUCCESS:
      return {
        ...state,
        rejectionReasons: action.payload,
      }
    case FetchRejectionReasonsToDecline.type.SUCCESS:
      return {
        ...state,
        rejectionReasonsToDecline: action.payload,
      }
    default:
      return state
  }
}
